import React from 'react';
import type { ClubPlanTier, OrgOperationType, SubscriptionTier } from '@court-sync/shared';
import { Button } from '@/components/ui';
import {
  formatClubPlanTierLabel,
  formatPlanTierLabel,
} from '../../utils/planRecommendationUi';

interface PricingSelectedPlanCardProps {
  operationType: OrgOperationType;
  academyTier?: SubscriptionTier;
  clubTier?: ClubPlanTier;
  billingInterval: 'month' | 'year';
  onChangePlan: () => void;
}

export function PricingSelectedPlanCard({
  operationType,
  academyTier,
  clubTier,
  billingInterval,
  onChangePlan,
}: PricingSelectedPlanCardProps) {
  const planLabel =
    operationType === 'both' && academyTier && clubTier
      ? `${formatPlanTierLabel(academyTier)} + ${formatClubPlanTierLabel(clubTier)}`
      : operationType === 'club' && clubTier
        ? formatClubPlanTierLabel(clubTier)
        : academyTier
          ? formatPlanTierLabel(academyTier)
          : 'Selected plan';

  return (
    <div className="mb-6 rounded-xl border border-primary-200/80 bg-gradient-to-br from-primary-50 via-white to-primary-50/40 p-4 shadow-sm dark:border-primary-500/25 dark:bg-gradient-to-br dark:from-primary-950/70 dark:via-background dark:to-primary-950/40 dark:shadow-[inset_0_1px_0_0_rgba(255,255,255,0.06)]">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-primary-700 dark:text-primary-300">
            Selected from pricing
          </p>
          <p className="text-lg font-semibold text-gray-900 dark:text-primary-50">{planLabel}</p>
          <p className="text-sm text-primary-800/80 dark:text-primary-200/75">
            Billed {billingInterval === 'year' ? 'annually' : 'monthly'} · 14-day free trial
          </p>
        </div>
        <Button type="button" variant="outline" size="sm" onClick={onChangePlan}>
          Change plan
        </Button>
      </div>
    </div>
  );
}
